// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"65d4e54b","408":"a410f117","423":"0bf80108"}[chunkId] + ".chunk.js";
};